import { type ReactNode } from "react";

import {
  EYEBROW_VARIANT_CLASSES,
  TONE_CLASSES,
  type EyebrowVariant,
  type TextTone,
} from "@/blueprint/tokens/Typography";
import { type TextElement } from "@/blueprint/components/Text/Text";
import { cn } from "@/lib/utils";

type EyebrowProps = {
  variant?: EyebrowVariant;
  tone?: TextTone;
  as?: TextElement;
  className?: string | undefined;
  children: ReactNode;
};

const Eyebrow = ({
  variant = "eyebrow-sm",
  tone = "secondary",
  as: Element = "p",
  className,
  children,
}: EyebrowProps) => (
  <Element
    className={cn(
      EYEBROW_VARIANT_CLASSES[variant],
      TONE_CLASSES[tone],
      className,
    )}
  >
    {children}
  </Element>
);

export default Eyebrow;
